/**
 * Человеческие названия причин простоя диспетчера.
 *
 * Причину считает сервер (§6.2) и присылает кодом из BLOCKED_REASONS — здесь только
 * перевод кода в текст. Таблица одна на всё приложение: админ на борде диспетчеров
 * и сам диспетчер на пустом пульте должны читать одну и ту же формулировку,
 * иначе разбор «почему не раздаётся» превращается в спор о словах.
 */

import type { BlockedReason } from '@cc/shared';

const TITLES: Record<BlockedReason, string> = {
  off_shift: 'Не на смене',
  not_ready: 'Перерыв',
  no_sip: 'Нет линии',
  no_ws: 'Пульт закрыт',
  daily_limit: 'Дневной лимит выбран',
  max_open: 'Держит открытые карточки',
};

export function blockedReasonTitle(reason: BlockedReason): string {
  return TITLES[reason];
}

/**
 * Что это значит и что с этим делать.
 *
 * Короткого названия диспетчеру мало: «Нет линии» он читает как «сломалось» и идёт
 * к администратору, хотя половина причин чинится им самим за пять секунд. Поэтому
 * рядом с названием печатается действие, а не пояснение к термину.
 *
 * Тексты живут рядом с названиями, а не в компоненте пульта: ту же причину
 * администратор видит на экране «Кто на смене», и две формулировки одного
 * состояния превращают разбор «почему не раздаётся» в спор о словах.
 */
const HINTS: Record<BlockedReason, string> = {
  off_shift:
    'По графику ваша смена сейчас не идёт, поэтому контакты не раздаются. График меняет администратор.',
  not_ready:
    'Вы не встали в готовность, и раздача вас пропускает. Нажмите «Готов» — контакты пойдут на ближайшем прогоне раздачи.',
  no_sip:
    'Линия на станции не зарегистрирована — звонить нечем, и контакты вам не раздаются. Разрешите браузеру микрофон и держите пульт в одной вкладке; если линия не поднялась за минуту, зовите администратора.',
  no_ws:
    'Сервер не получал сигнал от вашего пульта больше 90 секунд — обычно это оборвавшийся интернет. Проверьте связь и обновите страницу.',
  daily_limit:
    'Дневной лимит контактов выбран целиком. Новых сегодня не будет: лимит поднимает администратор.',
  max_open:
    'У вас на руках столько открытых карточек, сколько разрешено держать одновременно. Проставьте метки — раздача возобновится сама.',
};

export function blockedReasonHint(reason: BlockedReason): string {
  return HINTS[reason];
}
